exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".App_row_3n9nT{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.App_col_RW8kf{width:45%;padding:15px}.App_input_1PZDA{padding:10px;margin:10px;padding:10px!important;margin:10px!important}.App_output_1trMP{color:red;font-weight:900}.App_labelStyle_2D_vh{color:#000;font-size:12px;font-weight:900}.App_btn_oQ4Hz{padding:8px 20px;cursor:pointer;border-radius:5px;background-color:#000;color:#fff;border:0}.App_instructionsButton_PGaHV{font-size:17px;font-weight:700;text-decoration:underline;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-line-pack:start;align-content:flex-start;cursor:pointer;color:#000;-webkit-transition:.2s;transition:.2s;padding:15px}.App_textProp_2loTI{color:grey}.App_h2TextProp_1i1J4{margin-bottom:.5px;color:#000}.App_subHeading_3A2Bo{font-size:20px;color:#000}.App_bodyTextProp_P6Wvq{text-align:center;margin-bottom:10px;color:grey}", ""]);

// exports
exports.locals = {
	"row": "App_row_3n9nT",
	"col": "App_col_RW8kf",
	"input": "App_input_1PZDA",
	"output": "App_output_1trMP",
	"labelStyle": "App_labelStyle_2D_vh",
	"btn": "App_btn_oQ4Hz",
	"instructionsButton": "App_instructionsButton_PGaHV",
	"textProp": "App_textProp_2loTI",
	"h2TextProp": "App_h2TextProp_1i1J4",
	"subHeading": "App_subHeading_3A2Bo",
	"bodyTextProp": "App_bodyTextProp_P6Wvq"
};